module.exports = __webpack_public_path__ + "img/icon1.dbc082e2.png";